module.exports = __webpack_public_path__ + "fonts/Lato-Regular.1d2ca94.woff";